const apiUrl = process.env.REACT_APP_API_URL;
export const PostInscripcioFaltaDocumentacio = async ( idInst: string, page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8071/inscripcions/${idInst}/faltadocumentacio`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (!response.ok) {
            console.log(await response.text());
        }
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
